import * as React from "react";
import styled from "styled-components";

const StyledContainer = styled.div`
  padding: 12px 22px;
  border: 1px solid #e8e8e8;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const EntryComponentContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = props => {
  return <StyledContainer style={props.style}>{props.children}</StyledContainer>;
};
